import { Handler } from "../interfaces/Handler.interface";
import { Store } from "../interfaces/Store.interface";
import { deepSet } from "./deepSet";
import { emit } from "./emit";
import { getValue } from "./getValue";
import { updateReducer } from "../../infinity-engine/reducers/updateReducer";

interface SendConfig {
    store?: Store,
    handler?: Handler,
    sort?: boolean,
    batch?: boolean
};

export function send(updates: any, config: SendConfig = {}) {
    const { store, handler, sort, batch } = config;                             // Get variables from config.
    if (!store && !handler) return;                                             // If not passed operation object, return (cant do anything).

    if (store && batch) {
        store.preset = updates;                                                 // Preset values in store.
        updates = Object.keys(updates).reduce(updateReducer(store), updates);   // Cascade updates into single object.
        store.preset = undefined;                                               // Clear preset in store.
    }

    const keys = Object.keys(updates);                                            // Optionally sort keys.
    if (sort) keys.sort((a, b) => a.localeCompare(b));

    for (let i = 0; i < keys.length; i++) {                                     // Iterate over all update keys.
        let previous = getValue(keys[i], store);                                // Get previous value.
        if (store) deepSet(store, keys[i], updates[keys[i]]);                   // If given a store, set value in store.
        if (handler) emit(handler, keys[i], updates[keys[i]], previous);        // If given a handler, emit values to handler.
    }
}
